export const config = {
  env: 'development',
  isDev: true,
  apiURI: 'https://prerelease.enty.io/api',
  subscribesURI: 'wss://prerelease.enty.io/api',
  filestorage: 'https://pre-fs.enty.io',
  domainUrl: 'https://prepro.enty.io',
  // sentryDsn: 'https://07635677a9b040e59e6ecee0f0f70626@o508566.ingest.sentry.io/5601251',
} as const;
